import { gql } from "@apollo/client";

export const LOGIN = gql`
  mutation Login($input: LoginAdminDTO!) {
    login(input: $input) {
      message
      admin {
        _id
        name
        email
        contacts {
          dialCode
          number
        }
        dob
        address
        profileImageUrl
        role
        access
        lastLoginAt
        enabled2FA
        verified2FA
      }
      accessToken
      refreshToken
      expiresBy
      expiresAt
    }
  }
`;

export const REGISTER = gql`
  mutation CreateAdminUser($input: CreateAppUserDTO!) {
    createAdminUser(input: $input) {
      message
      user {
        _id
        email
        firstName
        lastName
        address
        bio
        status
        lastLoggedInAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation ($input: ForgotPasswordDTO!) {
    forgotPassword(input: $input) {
      message
    }
  }
`;

export const VERIFY_RESET_PASSWORD = gql`
  mutation ($input: ResetPasswordDTO!) {
    verifyToken(input: $input)
  }
`;
export const RESET_PASSWORD = gql`
  mutation ($input: ResetPasswordDTO!) {
    resetPassword(input: $input)
  }
`;

export const VERIFY_TOKEN = gql`
  mutation VerifyWebAppToken($input: ResetPasswordDTO!) {
    verifyWebAppToken(input: $input)
  }
`;

export const VERIFY_WEB_APP_TOKEN = gql`
  mutation ($input: ResetPasswordDTO!) {
    verifyWebAppToken(input: $input)
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation ($input: ChangePasswordDTO!) {
    changePassword(input: $input) {
      message
      status
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($refreshToken: String!) {
    refresh(refreshToken: $refreshToken) {
      accessToken
      refreshToken
    }
  }
`;

export const CODE_VERIFICATION = gql`
  mutation ($input: OtpVerificationFor2FADTO!) {
    otpVerificationFor2FA(input: $input) {
      admin {
        _id
        name
        email
        phone
        role
        status
      }
      refreshToken
      accessToken
    }
  }
`;
export const RESEND_OTP_CODE = gql`
  mutation ($input: Resend2FAOtpCodeDTO!) {
    resendOtpCode(input: $input) {
      expiresBy
      expiresAt
    }
  }
`;

export const RESEND_RESET_EMAIL = gql`
  mutation ResendEmailForReset($resendEmailForResetId: String!) {
    ResendEmailForReset(id: $resendEmailForResetId) {
      message
    }
  }
`;

export const UPLOAD_PROFILE_IMAGE = gql`
  mutation ($input: uploadProfileImageDTO!) {
    uploadProfileImage(input: $input) {
      url
    }
  }
`;

export const VERIFY_OTP = gql`
  mutation ($token: String!) {
    verifyAuthOTP(token: $token) {
      message
      recoveryCodes
    }
  }
`;

export const VALIDATE_OTP = gql`
  mutation ($input: validateAuthOTPInput!) {
    validateAuthOTP(input: $input) {
      message
      admin {
        _id
        name
        email
        role
        enabled2FA
      }
      refreshToken
      accessToken
    }
  }
`;

export const AUTH_OTP_DISABLE = gql`
  mutation ($token: String!) {
    disableAuthOTP(token: $token)
  }
`;

export const VERIFY_RECOVERY_CODE = gql`
  mutation VerifyRecoveryCodes($input: VerifyRecoveryCode!) {
    verifyRecoveryCodes(input: $input) {
      message
      admin {
        _id
        name
        email
        role
        enabled2FA
      }
      accessToken
      refreshToken
    }
  }
`;

export const RESET_AUTHENTICATOR_APP = gql`
  mutation ResetAuthenticatorApp($input: ResendAuthenticatorAppDTO!) {
    resetAuthenticatorApp(input: $input) {
      message
    }
  }
`;

export const VERIFY_RESET_AUTHENTICATOR_APP = gql`
  mutation ConfirmResetAuthenticatorApp($input: Reset2FACodeVerificationDTO!) {
    confirmResetAuthenticatorApp(input: $input) {
      message
      admin {
        _id
        name
        email
        contacts {
          dialCode
          number
          email
          emailVerified
        }
        dob
        address
        role
        access
        profileImage
        profileImageUrl
        createdAt
        lastLoginAt
        enabled2FA
        verified2FA
      }
      accessToken
      refreshToken
      expiresBy
      expiresAt
    }
  }
`;
